<po-modal #modal [p-hide-close]="true"
    [p-primary-action]="primaryActionBranch" [p-secondary-action]="secondaryActionBranch" p-title="Seleção de Empresa">
      <po-combo name="combo-branch" (p-change)="setBranch($event)" p-icon="an an-building-office"
        p-label="Escolha a Empresa" p-placeholder="Selecione uma Empresa" [p-options]="branchList">
      </po-combo>
</po-modal>